var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJumpRightEnable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.769,
    height: 11.676,
    viewBox: "0 0 16.769 11.676",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_1874",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1874",
    transform: "translate(-8.615 -10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_178",
    "data-name": "\\u30D1\\u30B9 178",
    d: "M48.308,21.738V10.845a.4.4,0,0,1,.677-.277l6.523,5.323a.493.493,0,0,1,0,.769l-6.523,5.385A.414.414,0,0,1,48.308,21.738Z",
    transform: "translate(-30.308 -0.461)",
    fill: "#07487E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_263",
    "data-name": "\\u30D1\\u30B9 263",
    d: "M48.308,21.738V10.845a.4.4,0,0,1,.677-.277l6.523,5.323a.493.493,0,0,1,0,.769l-6.523,5.385A.414.414,0,0,1,48.308,21.738Z",
    transform: "translate(-39.692 -0.461)",
    fill: "#07487E",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJumpRightEnable);
export default __webpack_public_path__ + "static/media/jump_right_enable.d374b424a6202b42c74d6787ca803932.svg";
export { ForwardRef as ReactComponent };